<template>
  <div class="content">
    <el-form class="form-box" :model="form" v-loading="repayLoading">
      <div class="top">
        <p>
          订单超过该时长未付款，订单状态记为已关闭，需要用户重新下单支付
        </p>
        <el-button type="primary" @click="onSaveSetting(0)">保存设置</el-button>
      </div>
      <el-form-item>
        <el-input
          class="input input-time"
          size="mini"
          v-model="form.no_pay_order_close_time"
          type="number"
          min="0"
        ></el-input
        ><span class="tip"
          >仅支持输入整数，设置0表示订单不设置失效关闭</span
        ></el-form-item
      ></el-form
    >
    <el-form class="form-box" :model="form" v-loading="percentLoading">
      <div class="top">
        <p>
          用户在线买单返红包设置：按实付金额的百分比返红包，支付成功即时到账
        </p>
        <el-button type="primary" @click="onSaveSetting(1)">保存设置</el-button>
      </div>
      <el-form-item>
        <el-input
          class="input input-percent"
          size="mini"
          v-model.number="form.pay_order_return_red_packet_rate"
          type="number"
          min="0"
          max="100"
        ></el-input
        ><span class="tip"
          >仅支持输入整数，设置0表示不返红包</span
        ></el-form-item
      ></el-form
    >
  </div>
</template>

<script>
import {
  setRedpacketPaySetting,
  getRedpacketExchangeSetting
} from '@/api/redpacket'

export default {
  data() {
    return {
      repayLoading: false,
      percentLoading: false,
      form: {
        no_pay_order_close_time: 0,
        pay_order_return_red_packet_rate: 0
      },
      data: null
    }
  },
  created() {
    this.repayLoading = true
    this.percentLoading = true
    getRedpacketExchangeSetting().then(res => {
      this.repayLoading = false
      this.percentLoading = false
      this.data = res.data
      this.form.no_pay_order_close_time = res.data.no_pay_order_close_time
      this.form.pay_order_return_red_packet_rate =
        res.data.pay_order_return_red_packet_rate
    })
  },
  methods: {
    onSaveSetting(index) {
      if (index === 0) {
        this.repayLoading = true
        setRedpacketPaySetting({
          no_pay_order_close_time: this.form.no_pay_order_close_time,
          pay_order_return_red_packet_rate: this.data
            .pay_order_return_red_packet_rate
        }).then(() => {
          this.data.no_pay_order_close_time = this.form.no_pay_order_close_time
          this.repayLoading = false
        })
      } else {
        this.percentLoading = true
        setRedpacketPaySetting({
          no_pay_order_close_time: this.data.no_pay_order_close_time,
          pay_order_return_red_packet_rate: this.form
            .pay_order_return_red_packet_rate
        }).then(() => {
          this.data.pay_order_return_red_packet_rate = this.form.pay_order_return_red_packet_rate
          this.percentLoading = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .form-box {
    background-color: #e0e0e0;
    padding: 20px;
    margin-bottom: 16px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    ::v-deeplabel {
      color: #333;
    }
    .input {
      position: relative;
      width: 160px;
      box-sizing: border-box;

      ::v-deepinput {
        padding-right: 32px;
      }
      &.input-time {
        &::after {
          content: '分钟';
          position: absolute;
          top: 50%;
          right: 4px;
          transform: translateY(-50%);
        }
      }
      &.input-percent {
        &::after {
          content: '%';
          position: absolute;
          top: 50%;
          right: 4px;
          transform: translateY(-50%);
        }
      }
    }
    .tip {
      background-color: orange;
      margin-left: 12px;
      color: #fff;
    }
  }
}
</style>
